import { render, staticRenderFns } from "./ProjectEditDetailsTab.vue?vue&type=template&id=f86ab4f2"
import script from "./ProjectEditDetailsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports